import React, { useContext, useEffect, useState } from "react";
import "./Cart_page.css";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import { useNavigate } from "react-router-dom";
import StickyComponent from "./Sticky_component";
import { Check, X, Trash } from "lucide-react";
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from "@mui/material";
import { paymentContext } from "./context";

function Cart_page() {
  const [cartItems, setCartItems] = useState([]);
  const [couponInUse, setCouponInUse] = useState(null);
  const [cartTotal, setCartTotal] = useState(0);
  const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [pincode, setPincode] = useState('');
  const [open, setOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [couponCode, setCouponCode] = useState('');

  const [canShip, setCanShip] = useState(false);
  const navigate = useNavigate();

  const {setCoupon} = useContext(paymentContext);
  const availableCoupons = {
    "FIRST": { code: "FIRST", discount: 100 },
    "SAVE10": { code: "SAVE10", discountPercent: 10 },
  };

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem('cart'));
    setCartItems(cart || []);
  }, []);

  useEffect(() => {
    calculateTotals();
  }, [cartItems, couponInUse, shippingCharge]);



  async function checkPincode() {
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/pincode-check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "pincode": pincode
        })
      })

      const data = await response.json();
      //console.log(data);
      if (data.statusCode == 200) {
        setCanShip(true);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  const handlePincodeChange = async (e) => {
    const value = e.target.value;
    setPincode(value);
  };

  function updateQuantity(index, newQuantity) {
    const updatedCart = [...cartItems];
    updatedCart[index].quantity = parseInt(newQuantity, 10);
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  function handleBlur(index) {
    const updatedCart = [...cartItems];
    if (!cartItems[index].quantity || isNaN(cartItems[index].quantity)) {
      updatedCart[index].quantity = 1; // Reset to 1 if empty or NaN
      setCartItems(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
    }
  }
  function removeItem(index) {
    const updatedCart = cartItems.filter((_, idx) => idx !== index);
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));

    // If cart becomes empty, reset other states
    if (updatedCart.length === 0) {
      setCouponInUse(null);
      setShippingCharge(0);
      setPincode('');
    }
  }

  const calculateSubtotal = (price, quantity) => (price * quantity).toFixed(2);

  function handleCouponChange(e) {
    const couponCode = e.target.value.toUpperCase();
    setCouponInUse(null);
    setCouponCode(couponCode);
  };

  async function applyCoupon() {
    if (couponCode === '') {
      setCouponInUse(null);
      setOpen(true);
      setDialogMessage('Please enter a valid coupon code.');
      return;
    }
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/coupon-retrieve', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "coupon_name": couponCode.toUpperCase(),
          "product_type": "All"
        })
      })
      const data = await response.json();
      if (data.statusCode == 200) {
        if (data.body.validity_status === "valid") {
          setCouponInUse(data.body);
          setOpen(true);
          setDialogMessage('Coupon applied successfully!');
          setCoupon(data.body)
          localStorage.setItem('coupon', JSON.stringify(data.body));
        } else {
          setOpen(true);
          setDialogMessage('Coupon no longer valid!');
        }
      } else {
        setOpen(true);
        setDialogMessage('Invalid coupon code!');
      }

    } catch (error) {
      console.error(error);
    }

    // if (availableCoupons[couponCode]) {
    //   setCouponInUse(availableCoupons[couponCode]);
    //   // alert('Coupon applied successfully!');
    //   setOpen(true);
    //   setDialogMessage('Coupon applied successfully!');

    // } else {
    //   // alert('Invalid coupon code!');
    //   setOpen(true);
    //   setDialogMessage('Invalid coupon code!');
    // }
  }


  function calculateTotals() {
    const subtotal = cartItems.reduce((total, item) => {
      return total + (item.price * item.quantity);
    }, 0);

    setCartTotal(subtotal);

    let finalTotal = subtotal;
    if (couponInUse) {
      if (couponInUse?.discount_applied) {
        finalTotal = Math.max(0, subtotal - couponInUse?.discount_applied);
      } else if (couponInUse?.discountPercent) {
        const discountAmount = (subtotal * couponInUse?.discountPercent) / 100;
        finalTotal = subtotal - discountAmount;
      }
    }
    finalTotal += shippingCharge;
    setTotalAfterDiscount(finalTotal.toFixed(2));
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>

      {
        (cartItems.length > 0)
          ? <div className="cart-page-container">
            <h1>Cart</h1>
            <div className="cart-page-table-container">
              <table className="cart-page-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Subtotal</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item, index) => (
                    <tr key={index}>

                      <td>
                        <div className="cart-page-product-info">
                          <img src={item.url} alt="Product" />
                          <span>{item.name}</span>
                        </div>
                      </td>
                      <td>₹{item.price}</td>
                      <td>
                        <input
                          type="number"
                          className="cart-page-quantity-input"
                          value={item.quantity}
                          min="1"
                          onChange={(e) => updateQuantity(index, e.target.value)}
                          onBlur={() => handleBlur(index)}
                        />
                      </td>
                      <td>₹{calculateSubtotal(item.price, item.quantity)}</td>
                      <td className="cart-page-delete-item">
                        <button
                          onClick={() => removeItem(index)}
                          className="cart-page-delete-item-btn"
                          aria-label="Remove item"
                        >
                          <Trash color="#ED1B24" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="cart-page-actions-container">
              <div className="cart-page-coupon-section">
                <input
                  type="text"
                  className="cart-page-coupon-input"
                  placeholder="Coupon code"
                  onChange={handleCouponChange}
                />
                <button className="cart-page-apply-coupon-btn" onClick={applyCoupon}>
                  Apply coupon
                </button>
              </div>
              <div className="cart-page-checkout-section">
                <button className="cart-page-checkout-btn" onClick={() => navigate('/checkout')}>Proceed to checkout</button>
              </div>
            </div>

            <div className="cart-totals-container">
              <h2 className="cart-totals-title">Cart totals</h2>
              <div className="cart-totals-row">
                <span className="cart-totals-label">Subtotal</span>
                <span className="cart-totals-value">₹{cartTotal.toFixed(2)}</span>
              </div>
              {
                couponInUse && (<div className="cart-totals-row">
                  <span className="cart-totals-label">Coupon applied ({couponInUse?.coupon_name})</span>
                  <span className="cart-totals-value">- ₹{(couponInUse?.discount_applied || (cartTotal * couponInUse.discountPercent / 100)).toFixed(2)}</span>
                </div>
                )}

              <div className="cart-totals-row">
                <span className="cart-totals-label">Shipping</span>

                <div className=" cart-page-shipping">
                  <input
                    type="number"
                    // className="w-24 p-2 border rounded"
                    placeholder="Pincode"
                    value={pincode}
                    onChange={handlePincodeChange}
                    maxLength={6}
                  />
                  <button onClick={checkPincode}>Check</button>
                  {canShip ?
                    <span className="text-gray-600"><Check size={25} color="green" /></span>
                    :
                    <span><X size={25} color="red" /></span>
                  }
                </div>
              </div>
              <div className="cart-totals-row">
                <span className="cart-totals-label">Total</span>
                <span className="cart-totals-value">₹{totalAfterDiscount}</span>
              </div>
            </div>

          </div>
          : <div className="cart-page-cart-empty-container">
            <div className="cart-page-cart-empty">
              <h1 className="cart-page-cart-empty-title">Your cart is empty</h1>
            </div>
            <button className="cart-page-continue-shopping" onClick={() => navigate('/')} >Continue Shopping</button>
          </div>

      }


      <About_p />
      <Footer />
      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }
      <StickyComponent />

      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>

  );
}

export default Cart_page;